import styled, { createGlobalStyle, css } from "styled-components";
import {RectangularButtonFilled} from "../../components/buttons";
import {LayoutConst} from "../../../core";
import {FlexBox} from "@brg/ui";
import {SendProjectButton} from "../../../_competition/components/SendProjectButton";
import {ActionsTitle, ActionsWrapper, CompetitionSubtitle} from "./styles";
import { BackdropContainer } from "shared/components/MobileSearchBar/styles";

export const SendProjectModalWrapper = styled(FlexBox)<{ isPopUpVisible?: boolean}>`
    position: relative;
    max-width: 1152px;
    margin-left: auto;
    margin-right: auto;
    width: 1152px;

    ${BackdropContainer} {
      z-index: 1 !important;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
      max-width: ${LayoutConst.container.xs}px;
      width: ${LayoutConst.container.xs}px;
      min-width: ${LayoutConst.container.xs}px;

      .project-butch-wrapper {
        margin: 20px auto 0 auto;
      }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      padding: 0 10px;
      width: 100%;
      min-width: auto;
      max-width: none;
      margin: 0;

      .project-butch-wrapper {
        margin: 20px auto 0 auto;
      }

    }
`

export const EmployActionsModalWrapper = styled(ActionsWrapper)<{zeroHeight?: boolean, fullWidth?: boolean}>`
  justify-content: center; 
  position: relative;
  padding-bottom: 0;
  margin-bottom: 0;
  width: 100%;

  .checkbox-noproject {
    margin-top: 32px;
    margin-bottom: 5px;

    @media (max-width:  ${LayoutConst.screen.s - 1}px) {
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }

  .checkbox {
    padding: 0;

    * {
      font-size: 17px !important;
      line-height: 22px !important;
      font-weight: 400 !important;
    }

    :hover {
      background-color: transparent;
    }
  }

  @media (max-width:  ${LayoutConst.screen.md}px) {
    width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};
  }

  @media (max-width:  ${LayoutConst.screen.s -1}px) {
    padding-bottom: ${({zeroHeight}) => zeroHeight ? 0 : '125px'};
  }
`

export const NoProjectsWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: 640px;
    flex-direction: column;
    row-gap: 25px;
    align-items: center;

    .checkbox {

      &:hover {
        background-color: transparent;
      }
      div {
        font-weight: 400;
      }
    }
    @media (max-width:  ${LayoutConst.screen.md}px) {
      .checkbox-noproject{
        width: auto;
      }
    }
    

  @media (max-width:  ${LayoutConst.screen.s - 1}px) {
    max-width: none;
    row-gap: 12px;
    width: 100% !important;
  }
`

export const CompleteWrapper = styled(NoProjectsWrapper)<{ noProjects?: boolean }>`
  max-width: 1049px;
  width: 1049px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (max-width:  ${LayoutConst.screen.md}px) {
    width: ${LayoutConst.container.xs}px;
    max-width: ${LayoutConst.container.xs}px;
    position: static;
    padding-top: ${({ noProjects }) => noProjects ? '120px' : '156px'};
    transform: none;
    top: auto;
    left: auto;
    row-gap: 16px;
  }

  @media (max-width:  ${LayoutConst.screen.s -1}px) {
    max-width: none;
    width: 100% !important;
    padding-top: ${({ noProjects }) => noProjects ? '0px' : '40px'};
    row-gap: 12px;
  }
`

export const DefaultDescription = styled.div`
  color: #151514;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.02em;
  text-align: center;

  @media (max-width:  ${LayoutConst.screen.s}px) {
    width: 85%;
    font-size: 13px;
    line-height: 16px;
    color: #545453;
  }
`

export const NoProjectsDescription = styled(DefaultDescription)`

`

export const CompleteDescription = styled(DefaultDescription)`
    text-align: center;

    color: ${({ theme }) => theme.catalog.descriptionColor};

    @media (max-width: ${LayoutConst.screen.l}px) {
      font-size: 17px;
      line-height: 22px;
      width: 600px;
      max-width: 600px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 13px;
      line-height: 16px;
      width: auto;
      max-width: calc(100% - 50px);
    }
`

export const CompleteTitle = styled(DefaultDescription)<{fixedWidth?: boolean, fullTitle?: boolean, noProjects?: boolean, mainTitle?: boolean, nowrap?: boolean }>`
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  color: ${(props) => props.theme.catalog.titleColor};
  text-align: center;
  width: ${({fixedWidth}) => fixedWidth ? '712px' : 'auto'};
  letter-spacing: -0.02em;
  ${p => p.nowrap && 'white-space: nowrap;'}

  @media (max-width:  ${LayoutConst.screen.md}px) {
    ${({ noProjects }) => noProjects && css`
      font-size: 30px;
      line-height: 40px;
    `}
  }

  @media (max-width:  ${LayoutConst.screen.s - 1}px) {
    font-size: ${({ mainTitle }) => mainTitle ? '28px' : '20px'};
    line-height: ${({ mainTitle }) => mainTitle ? '34px' : '25px'};
    letter-spacing: normal;
    max-width: ${({fullTitle}) => fullTitle ? '100%' : 'calc(100% - 33.5px)'};
    white-space: normal;
    text-align: left;
  }
`;
export const SendProjectsTitle = styled(CompleteTitle)`
    width: 100%;
    white-space: normal;
    text-align: left;
`;

export const SubtitleText = styled(DefaultDescription)`
font-weight: 400;
font-size: 17px;
line-height: 22px;
color: ${(props) => props.theme.catalog.subtitleColor};
text-align: center;
letter-spacing: -0.02em;
text-align: left;

@media (max-width:  ${LayoutConst.screen.md}px) {
  font-size: 15px;
  line-height: 20px;
}

@media (max-width:  ${LayoutConst.screen.s - 1}px) {
  font-size: 13px;
  line-height: 16px;
}
`

export const NoProjectsButton = styled(RectangularButtonFilled)`
  //width: 228px;
  margin-top: 24px;
  height: 48px!important;
  padding: 12px 48px;
  font-family: 'Inter';

  @media (max-width:  ${LayoutConst.screen.s}px) {
    width: calc(100% - 20px);
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
    max-width: 339px;
  }

  @media (max-width:  ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
    max-width: none;
    white-space: nowrap;
  }
`

export const SendEmployProjectButton = styled(SendProjectButton)<{ staticPosition?: boolean }>`
  min-width: 138px;
  max-width: 166px;
  padding: 13px 48px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 10px 37.5px;
  }

  ${({ staticPosition }) => staticPosition ? css`
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      position: static;
      width: 100%;
      border-radius: 3px 3px 0 0;
      z-index: 1000;
      max-width: none;
      min-width: 100%;
      padding: 0;
    }
  
  ` : css`
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      position: fixed;
      bottom: 10px;
      left: 10px;
      width: calc(100% - 20px);
      height: 46px;
      border-radius: 3px;
      z-index: 1000;
      min-width: auto;
      max-width: none;
    }
  `};
`

export const CompetitionModalGS = createGlobalStyle`

  ${CompleteTitle} {
    color: #fefefe;
  }

  ${CompetitionSubtitle} {
    @media (max-width: ${LayoutConst.screen.md}px) {
      display: none;
    }
  }

  ${ActionsTitle} {
    @media (max-width:  ${LayoutConst.screen.md}px) {
      ${CompetitionSubtitle} {
        display: flex !important;
      }
    }
  }
`;import styled, { createGlobalStyle, css } from "styled-components";
import {RectangularButtonFilled} from "../../components/buttons";
import {LayoutConst} from "../../../core";
import {FlexBox} from "@brg/ui";
import {SendProjectButton} from "../../../_competition/components/SendProjectButton";
import {ActionsTitle, ActionsWrapper, CompetitionSubtitle} from "./styles";
import { BackdropContainer } from "shared/components/MobileSearchBar/styles";

export const SendProjectModalWrapper = styled(FlexBox)<{ isPopUpVisible?: boolean}>`
    position: relative;
    max-width: 1152px;
    margin-left: auto;
    margin-right: auto;
    width: 1152px;

    ${BackdropContainer} {
      z-index: 1 !important;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
      max-width: ${LayoutConst.container.xs}px;
      width: ${LayoutConst.container.xs}px;
      min-width: ${LayoutConst.container.xs}px;

      .project-butch-wrapper {
        margin: 20px auto 0 auto;
      }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      padding: 0 10px;
      width: 100%;
      min-width: auto;
      max-width: none;
      margin: 0;

      .project-butch-wrapper {
        margin: 20px auto 0 auto;
      }

    }
`

export const EmployActionsModalWrapper = styled(ActionsWrapper)<{zeroHeight?: boolean, fullWidth?: boolean}>`
  justify-content: center; 
  position: relative;
  padding-bottom: 0;
  margin-bottom: 0;
  width: 100%;

  .checkbox-noproject {
    margin-top: 32px;
    margin-bottom: 5px;

    @media (max-width:  ${LayoutConst.screen.s - 1}px) {
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }

  .checkbox {
    padding: 0;

    * {
      font-size: 17px !important;
      line-height: 22px !important;
      font-weight: 400 !important;
    }

    :hover {
      background-color: transparent;
    }
  }

  @media (max-width:  ${LayoutConst.screen.md}px) {
    width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};
  }

  @media (max-width:  ${LayoutConst.screen.s -1}px) {
    padding-bottom: ${({zeroHeight}) => zeroHeight ? 0 : '125px'};
  }
`

export const NoProjectsWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: 640px;
    flex-direction: column;
    row-gap: 25px;
    align-items: center;

    .checkbox {

      &:hover {
        background-color: transparent;
      }
      div {
        font-weight: 400;
      }
    }
    @media (max-width:  ${LayoutConst.screen.md}px) {
      .checkbox-noproject{
        width: auto;
      }
    }
    

  @media (max-width:  ${LayoutConst.screen.s - 1}px) {
    max-width: none;
    row-gap: 12px;
    width: 100% !important;
  }
`

export const CompleteWrapper = styled(NoProjectsWrapper)<{ noProjects?: boolean }>`
  max-width: 1049px;
  width: 1049px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (max-width:  ${LayoutConst.screen.md}px) {
    width: ${LayoutConst.container.xs}px;
    max-width: ${LayoutConst.container.xs}px;
    position: static;
    padding-top: ${({ noProjects }) => noProjects ? '120px' : '156px'};
    transform: none;
    top: auto;
    left: auto;
    row-gap: 16px;
  }

  @media (max-width:  ${LayoutConst.screen.s -1}px) {
    max-width: none;
    width: 100% !important;
    padding-top: ${({ noProjects }) => noProjects ? '0px' : '40px'};
    row-gap: 12px;
  }
`

export const DefaultDescription = styled.div`
  color: #151514;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.02em;
  text-align: center;

  @media (max-width:  ${LayoutConst.screen.s}px) {
    width: 85%;
    font-size: 13px;
    line-height: 16px;
    color: #545453;
  }
`

export const NoProjectsDescription = styled(DefaultDescription)`

`

export const CompleteDescription = styled(DefaultDescription)`
    text-align: center;

    color: ${({ theme }) => theme.catalog.descriptionColor};

    @media (max-width: ${LayoutConst.screen.l}px) {
      font-size: 17px;
      line-height: 22px;
      width: 600px;
      max-width: 600px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 13px;
      line-height: 16px;
      width: auto;
      max-width: calc(100% - 50px);
    }
`

export const CompleteTitle = styled(DefaultDescription)<{fixedWidth?: boolean, fullTitle?: boolean, noProjects?: boolean, mainTitle?: boolean, nowrap?: boolean }>`
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  color: ${(props) => props.theme.catalog.titleColor};
  text-align: center;
  width: ${({fixedWidth}) => fixedWidth ? '712px' : 'auto'};
  letter-spacing: -0.02em;
  ${p => p.nowrap && 'white-space: nowrap;'}

  @media (max-width:  ${LayoutConst.screen.md}px) {
    ${({ noProjects }) => noProjects && css`
      font-size: 30px;
      line-height: 40px;
    `}
  }

  @media (max-width:  ${LayoutConst.screen.s - 1}px) {
    font-size: ${({ mainTitle }) => mainTitle ? '28px' : '20px'};
    line-height: ${({ mainTitle }) => mainTitle ? '34px' : '25px'};
    letter-spacing: normal;
    max-width: ${({fullTitle}) => fullTitle ? '100%' : 'calc(100% - 33.5px)'};
    white-space: normal;
    text-align: left;
  }
`;
export const SendProjectsTitle = styled(CompleteTitle)`
    width: 100%;
    white-space: normal;
    text-align: left;
`;

export const SubtitleText = styled(DefaultDescription)`
font-weight: 400;
font-size: 17px;
line-height: 22px;
color: ${(props) => props.theme.catalog.subtitleColor};
text-align: center;
letter-spacing: -0.02em;
text-align: left;

@media (max-width:  ${LayoutConst.screen.md}px) {
  font-size: 15px;
  line-height: 20px;
}

@media (max-width:  ${LayoutConst.screen.s - 1}px) {
  font-size: 13px;
  line-height: 16px;
}
`

export const NoProjectsButton = styled(RectangularButtonFilled)`
  //width: 228px;
  margin-top: 24px;
  height: 48px!important;
  padding: 12px 48px;
  font-family: 'Inter';

  @media (max-width:  ${LayoutConst.screen.s}px) {
    width: calc(100% - 20px);
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
    max-width: 339px;
  }

  @media (max-width:  ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
    max-width: none;
    white-space: nowrap;
  }
`

export const SendEmployProjectButton = styled(SendProjectButton)<{ staticPosition?: boolean }>`
  min-width: 138px;
  max-width: 166px;
  padding: 13px 48px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 10px 37.5px;
  }

  ${({ staticPosition }) => staticPosition ? css`
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      position: static;
      width: 100%;
      border-radius: 3px 3px 0 0;
      z-index: 1000;
      max-width: none;
      min-width: 100%;
      padding: 0;
    }
  
  ` : css`
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      position: fixed;
      bottom: 10px;
      left: 10px;
      width: calc(100% - 20px);
      height: 46px;
      border-radius: 3px;
      z-index: 1000;
      min-width: auto;
      max-width: none;
    }
  `};
`

export const CompetitionModalGS = createGlobalStyle`

  ${CompleteTitle} {
    color: #fefefe;
  }

  ${CompetitionSubtitle} {
    @media (max-width: ${LayoutConst.screen.md}px) {
      display: none;
    }
  }

  ${ActionsTitle} {
    @media (max-width:  ${LayoutConst.screen.md}px) {
      ${CompetitionSubtitle} {
        display: flex !important;
      }
    }
  }
`;